<h4 mat-dialog-title>Necesitamos datos adicionales.</h4>
<div mat-dialog-content>
    <p *ngFor="let cost of data.additionalCosts">* {{ cost }}</p>
    <br>
    <p>Un operador se va a estar comunicando con vos.</p>
    
    <mat-form-field class="col-5 p-2">
        <div class="phone-container">
            <span>(0&nbsp;</span>
            <input matInput type="tel" numeric [(ngModel)]="data.contactPhone.Code" maxlength="4" autocomplete="off">
            <span>)</span>
        </div>
        <mat-hint>Cód. área</mat-hint>
    </mat-form-field>

    <mat-form-field class="col-7 p-2">
        <div class="phone-container">
            <span [hidden]="data.contactPhone.Type == 'Fijo'">15&nbsp;</span>
            <input matInput type="tel" numeric [(ngModel)]="data.contactPhone.Number" maxlength="8" autocomplete="off">
        </div>
        <mat-icon matSuffix>phone</mat-icon>
        <mat-hint>Número</mat-hint>
    </mat-form-field>
    
</div>
<div mat-dialog-actions class="p-0 justify-content-between">
    <button mat-button color="warn" [mat-dialog-close]="false">Cancelar</button>
    <button mat-button color="accent" [mat-dialog-close]="data.contactPhone" [disabled]="!IsValidPhone()">Aceptar</button>
</div>